import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["addNestedItem", "nestedItem"]
    static values = {
        maxNestedItems: Number
    }

    connect() {
        this.checkNestedItemsCount()
    }

    checkNestedItemsCount() {
        const visibleItems = this.nestedItemTargets.filter(item => item.style.display !== "none")

        if (visibleItems.length >= this.maxNestedItemsValue) {
            this.addNestedItemTarget.classList.add("hidden")
        } else {
            this.addNestedItemTarget.classList.remove("hidden")
        }
    }
}
